import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccessResponse } from 'src/app/personal-info/models/personal-info.model';
import { UrlMapService } from 'src/app/shared-resources/services/url-map.service';
import { LeadsPreference, LeadsReferralBuyer } from '../models/leads-crm.model';

@Injectable({
  providedIn: 'root'
})
export class LeadsCrmService {

  
  /** return selected menu  */
  get selectedMenu(): string {
    return sessionStorage.getItem('leadsSelectedMenu') as string;
  }

  constructor(
    private urlMapService: UrlMapService,
    private httpClient: HttpClient
  ) { 
    // blank constructor
  }

  /** update selected leads/crm menu */
  public updateSelectedMenu(menuName: string): void {
    sessionStorage.setItem('leadsSelectedMenu', menuName);
  }
    
  /** get leads preference from db */
  public getLeadsPreference(agentNumber: string): Observable<LeadsPreference | null> {
    let url = this.urlMapService.leadsCRMUrl() + agentNumber + '/preference';
    return this.httpClient.get<LeadsPreference>(url);
  }

  /**  save leads preference */
  public saveLeadsPreference(data: any): Observable<AccessResponse> {
    let url = this.urlMapService.leadsCRMUrl() + 'preference';
    return this.httpClient.put<AccessResponse>(url, data);
  }

   /** get Rental Lead from db */
   public getRentalLead(agentNumber: string): Observable<LeadsPreference> {
    let url = this.urlMapService.leadsCRMUrl() + agentNumber + '/rental-lead';
    return this.httpClient.get<LeadsPreference>(url);
  }

  /** get Rental Lead from db */
  public getZipcode(agentNumber: string, stateID:string): Observable<LeadsPreference> {
  let url = this.urlMapService.leadsCRMUrl() + agentNumber + '/zipcodes/' + stateID;
  return this.httpClient.get<LeadsPreference>(url);
  }

  /** get leads referral from db */
  public getLeadsReferral(agentNumber: string): Observable<LeadsReferralBuyer> {
    let url = this.urlMapService.leadsCRMUrl() + agentNumber + '/buyer-referral';
    return this.httpClient.get<LeadsReferralBuyer>(url);
  }

    /**  save leads referral */
    public saveBuyerLeadReferral(agentNumber: string, optIn: boolean ): Observable<AccessResponse> {
      let url = this.urlMapService.leadsCRMUrl() + agentNumber + '/buyer-referral/' + optIn;
      return this.httpClient.put<AccessResponse>(url, null);
    }

  /**  save Rental leads routing */
  public saveRentalLeadRouting(agentNumber: string, isSuspend: boolean, data: any ): Observable<AccessResponse> {
    let url = this.urlMapService.leadsCRMUrl() + agentNumber + '/rental-lead?isSuspend='+ isSuspend;
    return this.httpClient.put<AccessResponse>(url, data);
  }

  /** get contact info api method */
  public getContactInfo(agentNumber: string): Observable<any> {
    const url = this.urlMapService.getContactInfoUrl() + agentNumber + '/contact-info';
    return this.httpClient.get<any>(url);
  }
}
